<template>
  <ImportWizardTable
    :identifier="identifier"
    :content-rows="mappedData.rows"
    :content-headers="mappedData.headers"
  />
</template>

<script>
import ImportWizardTable from "@/views/Pages/AdminModule/ImportModule/Partials/Wizard/ImportWizardTable.vue";

export default {
  components: { ImportWizardTable },

  props: {
    mapping: {
      default: () => {},
    },
    identifier: {
      type: Object,
      default: () => null,
    },
    uploadedData: {
      type: Object,
      default: () => {},
    },
    templateFields: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [],
      rows: [],
    };
  },

  created() {
    this.handlePreview();
  },

  methods: {
    handlePreview() {
      const headers = Object.keys(this.mapping);
      const csv = this.uploadedData;

      const mappedDataHeaders = this.templateFields
        .filter((item) => headers.includes(item?.code))
        .map((item) => item?.code);

      const headerIndices = mappedDataHeaders.map((header) =>
        csv.headers.indexOf(this.mapping[header])
      );

      this.headers = headers;
      const rows = csv.rows?.map((row) =>
        headerIndices.map((index) => row[index])
      );

      this.rows = rows;

      this.$emit("preview-data", rows);
    },
  },

  computed: {
    mappedData() {
      const headers = this.templateFields
        .filter((item) => this.headers.includes(item?.code))
        .map((item) => item?.code);
      return { headers, rows: this.rows };
    },
  },
};
</script>
